/**
 * Reads the Supabase session from localStorage synchronously.
 *
 * Does NOT import @supabase/supabase-js — keeping this hook out of the
 * marketing page bundle is the whole point. Supabase persists sessions under
 * the key pattern: sb-<projectRef>-auth-token
 *
 * Returns true if a non-empty access_token is present, false otherwise.
 *
 * This is a one-shot synchronous read — it does NOT subscribe to storage events.
 * A page reload is required to reflect sign-in/sign-out changes on marketing pages.
 */
export function useLocalSession(): boolean {
  if (typeof window === 'undefined') return false;
  const key = Object.keys(localStorage).find(
    (k) => k.startsWith('sb-') && k.endsWith('-auth-token'),
  );
  if (!key) return false;
  try {
    const val = JSON.parse(localStorage.getItem(key) ?? 'null');
    return typeof val?.access_token === 'string' && val.access_token.length > 0;
  } catch {
    return false;
  }
}
